import { z } from 'zod';

import { TestQuestionWritableShape } from '../test-question-create/test-question-create';

/**
 * Editing a question (`courses.manage`).
 *
 * Partial, so a locale tab can save alone — but `options`, when present, is the
 * **whole** set: see `TestQuestionOptionWriteSchema` for why an option set is
 * replaced rather than patched.
 */
export const TestQuestionUpdateSchema = z.object(TestQuestionWritableShape).partial().strict();

export type TestQuestionUpdateRequest = z.infer<typeof TestQuestionUpdateSchema>;
